import Repository from './Repository';

const resource = '/finishings';
export default {
  get() {
    return Repository.get(`${resource}?p=y`);
  },
};
